import { useQuery } from "@tanstack/react-query";

import { useViewer } from "@/hooks/use-viewer";
import { distributionAvailabilityQueryOptions } from "@/lib/distribution-availability-query";

export function useDistributionAvailability() {
  const viewer = useViewer();
  const query = useQuery(distributionAvailabilityQueryOptions(viewer.userId, viewer.identity));
  // A failed bootstrap is unknown, not a confirmed unavailable channel.
  return { ...query, isLoading: [query.isLoading, query.data === null].some(Boolean) };
}
